import { css } from 'styled-components'

/**
 * FE-PERF-1 FE1.1: this snippet lives in its own file because the
 * platform's global stylesheet (`src/App/global.styles.ts`, boot
 * path) needs it. When it lived inside `GeocoderControl.tsx`, that
 * import dragged the whole `@mapbox/mapbox-gl-geocoder` bundle into
 * the entry chunk although no boot code renders a map. Keep this
 * file free of JS dependencies beyond styled-components.
 */
export const MapboxGeocoderStyle = css`
  .mapboxgl-ctrl-geocoder .suggestions {
    max-height: 300px;
    overflow-y: auto;
  }
`
